export default __webpack_public_path__ + "static/media/avatar_4.3c53126b.png";